<template>
  <div :class="['content', programStyle]" v-if="form">
    <div class="appeal-container">
      <div class="appeal-details">
        <span class="section-title">{{ selectedForm.layout }} Review Tracking</span>
        <span class="section-label">Request Details:</span>
        <div class="request-details flex-column">
          <ul>
            <li><span>Dealer:</span> {{ selectedForm.dealerName }}</li>
            <li v-if="selectedForm.entity"><span>Dealer Code:</span> {{ selectedForm.entity }}</li>
            <li><span>BC:</span> {{ selectedForm.bc }}</li>
            <li><span>Sales District:</span> {{ selectedForm.salesDistrict }}</li>
            <li><span>Service District:</span> {{ selectedForm.serviceDistrict }}</li>
          </ul>
        </div>
        <span class="section-title">Review Status</span>
      </div>
      <DataTable :headings="fieldReviewTH" :rows="stepRows" :perPage="rowCount" :page="currentPage"> </DataTable>
    </div>
    <div class="form-container" v-if="appeals">
      <div class="item-container" v-for="appeal in appeals" :key="appeal.dialId">
        <div class="left-container flex-column">
          <div :class="['circle', appeal.dialColor]">
            <div class="inner" v-if="appeal.dialResultText">
              {{ appeal.dialResultText }}
            </div>
          </div>
        </div>
        <div class="right-container flex-column">
          <div class="subtitle">{{ appeal.dialTitle }}</div>
          <div class="description" v-if="selectedForm.layout === 'Proof of Service Lift'">
            <h4>
              You must upload photos of <u><b>all</b></u> the following:
            </h4>
            <ol>
              <li>Lift with 3 stage arms visible</li>
              <li>Vehicle Lift Specification Label</li>
            </ol>
          </div>
          <div class="description" v-if="selectedForm.layout === 'Proof of Forklift'">
            <h4>
              You must upload photos of <u><b>one</b></u> the following:
            </h4>
            <ul>
              <li>Forklift Invoice</li>
              <li>Forklift Data Plate</li>
              <li>Forklift Rental Agreement</li>
            </ul>
          </div>
          <div class="description" v-if="selectedForm.layout === 'Proof of Door Dimension'">
            <h4>
              You must upload photos of <u><b>ALL</b></u> the following:
            </h4>
            <h4>Proof of Door Dimensions 13ft. High and 10ft. Wide</h4>
            <ol>
              <li>Photo from exterior of entire service door with a Stellantis vehicle in frame for reference.</li>
            </ol>
          </div>
          <div class="description" v-if="selectedForm.layout === 'Proof of Ceiling Height'">
            <h4>
              You must upload photos of <u><b>ALL</b></u> the following:
            </h4>
            <ol>
              <li>Photo of the service bay with a Stellantis vehicle in frame for reference.</li>
            </ol>
          </div>
          <div v-if="appeal.uploads.length > 0">{{ $t('supporting-documents-0') }}</div>
          <div v-if="appeal.uploads">
            <div class="support-docs" v-for="upload in appeal.uploads" :key="upload.key">
              <span v-if="upload.label === appeal.dialTitle">{{ upload.originalFilename }}</span>
              <a v-if="upload.label === appeal.dialTitle" class="relative" target="_blank" :href="upload.url">
                <img class="download-icon" src="@/assets/img/download-arrow.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container" v-for="status in stepRows" :key="status.stepName">
        <div
          class="bottom-info bottom-border"
          v-if="status.id && status.stepName !== 'Dealer' && status.result !== 'Pending'"
        >
          <span class="section-title" v-if="status.stepName === 'HQ'">Tracking History</span>
          <span class="section-label">{{ status.stepName }}:</span>
          <span class="section-label">* Review Form:</span>
          <div class="dial">
            <div class="flex-row radio-container">
              <button :class="status.result === 'Approved' ? 'radio-selected' : 'radio'" @click="result = 'Approved'">
                <div v-if="status.result === 'Approved'" class="selected"></div>
              </button>
              <span>{{ $t('approve') }}</span>
            </div>
            <div class="flex-row radio-container">
              <button :class="status.result === 'Declined' ? 'radio-selected' : 'radio'">
                <div v-if="status.result === 'Declined'" class="selected"></div>
              </button>
              <span>{{ $t('deny') }}</span>
            </div>
          </div>
          <span class="label">Reason:</span>
          <textarea readonly v-model="status.reason" />
          <div class="flex-row input-info">
            <div class="flex-column">
              <span class="label">* Name:</span>
              <input readonly v-model="status.name" />
            </div>
            <div class="flex-column">
              <span class="label">* Title:</span>
              <input readonly v-model="status.title" />
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container">
        <div
          class="bottom-info"
          v-if="
            (form.permissions[0].canSubmit || form.permissions[0].canOverride) &&
            (form.header[0].layout === 'Proof of Forklift' ||
              form.header[0].layout === 'Proof of Service Lift' ||
              form.header[0].layout === 'Proof of Door Dimension' ||
              form.header[0].layout === 'Proof of Ceiling Height') &&
            hqReviewStatus !== 'Declined'
          "
        >
          <span class="section-title">Current Status</span>
          <span class="section-label">{{ currentLevel }}:</span>
          <span class="section-label">* Review Form:</span>
          <div class="dial">
            <div
              class="flex-row radio-container"
              v-if="reviewerLevelStatus === 'Pending' || reviewerLevelStatus === 'Declined'"
            >
              <button :class="result === 'Approved' ? 'radio-selected' : 'radio'" @click="result = 'Approved'">
                <div v-if="result === 'Approved'" class="selected"></div>
              </button>
              <span>{{ $t('approve') }}</span>
            </div>
            <div
              class="flex-row radio-container"
              v-if="reviewerLevelStatus === 'Pending' || reviewerLevelStatus === 'Approved'"
            >
              <button :class="result === 'Declined' ? 'radio-selected' : 'radio'" @click="result = 'Declined'">
                <div v-if="result === 'Declined'" class="selected"></div>
              </button>
              <span>{{ $t('deny') }}</span>
            </div>
          </div>
          <span class="label">{{ $t('reason-0') }}:</span>
          <GInput
            type="textarea"
            v-model="reason"
            placeholder="Enter a reason"
            maxlength="1000"
            :showCount="true"
          ></GInput>
          <div class="flex-row input-info">
            <div class="flex-column">
              <span class="label">* {{ $t('name') }}:</span>
              <input readonly v-model="name" />
            </div>
            <div class="flex-column">
              <span class="label">* {{ $t('title') }}:</span>
              <div class="custom-input flex-row">
                <input placeholder="Enter title" v-model="title" />
                <span class="custom-input-buttons flex-row">
                  <span class="edit-button" :class="[title ? '' : 'disabled']" @click="title = null">{{
                    $t('clear')
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <span class="section-label">* Signature:</span>
          <div class="signature-section flex-column">
            <div class="flex-row signature-input">
              <div class="signature-icon"><SignatureIcon /></div>
              <VueSignaturePad id="signature" width="400px" height="100px" ref="signaturePad" :options="options" />
            </div>
            <span class="signature-confirmation" v-if="signature">{{ $t('signature-saved') }}</span>
            <div class="signature-buttons flex-row">
              <span class="custom-input-buttons flex-row">
                <span class="edit-button" @click="saveSignature">{{ $t('save-signature') }}</span
                ><span class="separator">|</span
                ><span class="edit-button" @click="clearSignature">{{ $t('clear') }}</span>
              </span>
            </div>
          </div>
        </div>
        <div
          class="bottom-info"
          v-if="
            form.permissions[0].canSubmit &&
            (currentLevel === 'EVR Audit' || currentLevel === 'Auditor') &&
            selectedForm.layout !== 'Proof of Service Lift' &&
            selectedForm.layout !== 'Proof of Forklift' &&
            selectedForm.layout !== 'Proof of Door Dimension' &&
            selectedForm.layout !== 'Proof of Ceiling Height'
          "
        >
          <span class="section-title">Current Status</span>
          <span class="section-label">{{ currentLevel }}</span>
          <span
            class="section-label"
            v-if="
              (currentLevel === 'EVR Audit' || currentLevel === 'Auditor') &&
              this.selectedForm.layout !== 'Proof of Forklift' &&
              this.selectedForm.layout !== 'Proof of Service Lift' &&
              selectedForm.layout !== 'Proof of Door Dimension' &&
              selectedForm.layout !== 'Proof of Ceiling Height'
            "
            >* Review Form:</span
          >
          <div class="dial">
            <div
              class="flex-row radio-container"
              v-if="!reviewerLevelStatus || reviewerLevelStatus === 'Approved' || reviewerLevelStatus === 'Pending'"
            >
              <button :class="result === 'Declined' ? 'radio-selected' : 'radio'" @click="result = 'Declined'">
                <div v-if="result === 'Declined'" class="selected"></div>
              </button>
              <span>{{ $t('deny') }}</span>
            </div>
          </div>
          <span class="label">{{ $t('reason-0') }}:</span>
          <GInput
            type="textarea"
            v-model="reason"
            placeholder="Enter a reason"
            maxlength="1000"
            :showCount="true"
          ></GInput>
          <div class="flex-row input-info">
            <div class="flex-column">
              <span class="label">* {{ $t('name') }}:</span>
              <input readonly v-model="name" />
            </div>
            <div class="flex-column">
              <span class="label">* {{ $t('title') }}:</span>
              <div class="custom-input flex-row">
                <input placeholder="Enter title" v-model="title" />
                <span class="custom-input-buttons flex-row">
                  <span class="edit-button" :class="[title ? '' : 'disabled']" @click="title = null">{{
                    $t('clear')
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <span class="section-label">* Signature:</span>
          <div class="signature-section flex-column">
            <div class="flex-row signature-input">
              <div class="signature-icon"><SignatureIcon /></div>
              <VueSignaturePad id="signature" width="400px" height="100px" ref="signaturePad" :options="options" />
            </div>
            <span class="signature-confirmation" v-if="signature">{{ $t('signature-saved') }}</span>
            <div class="signature-buttons flex-row">
              <span class="custom-input-buttons flex-row">
                <span class="edit-button" @click="saveSignature">{{ $t('save-signature') }}</span
                ><span class="separator">|</span
                ><span class="edit-button" @click="clearSignature">{{ $t('clear') }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="button-container flex-row">
          <button
            v-if="form.permissions[0].canSubmit || form.permissions[0].canOverride"
            value="save"
            @click="save"
            :class="[fullValidationCheck ? '' : 'disabled']"
          >
            {{ $t('submit') }}
          </button>
          <button class="cancel-button" @click="exit">{{ $t('exit') }}</button>
          <div v-if="invalidPermissions">
            {{ $t('contact-admin') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';
import DataTable from '@/components/DataTable.vue';
import GInput from '@/components/GComponents/GInput.vue';
import { mapState } from 'vuex';
import fieldReviewTH from '@/utils/tableHeaders/fieldReviewTH';
import SignatureIcon from '@/assets/icons/delete-icn.svg';

export default {
  name: 'FieldAcknowledgement',
  components: { DataTable, GInput, SignatureIcon },
  props: {
    selectedForm: {
      type: Object,
    },
  },
  data() {
    return {
      value: 'appeals',
      date: new Date(),
      status: null,
      form: null,
      rowCount: 7,
      currentPage: 1,
      stepRows: [],
      formInfo: null,
      appeals: [],
      formId: null,
      result: null,
      reason: null,
      title: null,
      options: {
        penColor: '#000000',
      },
      signature: null,
      invalidPermissions: false,
      fieldReviewTH: fieldReviewTH(),
      currentLevel: null,
    };
  },
  methods: {
    save() {
      if (this.fullValidationCheck) {
        const params = {
          formId: this.selectedForm.formId,
          result: this.result,
          fieldSignature: this.signature,
          reason: this.reason,
          title: this.title,
        };
        this.submitFieldForm(params);
      }
    },
    submitFieldForm(params) {
      this.$store
        .dispatch('updateForm', params)
        .then((res) => {
          if (res === 'invalid_permissions') {
            this.invalidPermissions = true;
          } else {
            this.$notify({
              group: 'primary',
              type: 'success',
              text: this.$t('form-successfully-submitted'),
            });
            this.exit();
          }
        })
        .catch(() => {});
    },
    exit() {
      this.$emit('exit');
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.signature = data;
      }
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.signature = null;
    },
    getForm() {
      const loader = this.$loading.show();
      const { formId } = this.selectedForm;

      this.$store
        .dispatch('getForm', { formId })
        .then((res) => {
          if (res) {
            this.form = res;
            this.form.steps.forEach((step) => {
              if (step.status.id) {
                this.$set(step.status, 'stepName', step.stepName);
                this.stepRows.push(step.status);
              } else {
                this.stepRows.push({
                  stepName: step.stepName,
                  result: 'Pending',
                });
              }
            });
            this.form.items.forEach((item) => {
              this.appeals.push(item);
            });
            // logic for auditors & hqs
            this.currentLevel = this.stepRows.find((step) => step.stepName !== 'Dealer' && step.result === 'Pending')
              ?.stepName
              ? this.stepRows.find((step) => step.stepName !== 'Dealer' && step.result === 'Pending')?.stepName
              : 'HQ';
            this.reviewerLevelStatus = this.stepRows.find((step) => step.stepName === 'HQ')?.result;
            if (
              this.form.header[0].layout !== 'Proof of Service Lift' &&
              this.form.header[0].layout !== 'Proof of Forklift' &&
              this.form.header[0].layout !== 'Proof of Door Dimension' &&
              this.form.header[0].layout !== 'Proof of Ceiling Height'
            ) {
              this.currentLevel = this.stepRows[this.stepRows.length - 1].stepName;
            }
          }
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  computed: {
    ...mapState('global', ['programStyle']),
    name() {
      const user = JSON.parse(localStorage.getItem('stellantis-user'));
      const fullName = `${user.firstName} ${user.lastName}`;

      return fullName;
    },
    fullValidationCheck() {
      if (this.title && this.reason && this.signature && this.result) {
        return true;
      }
      return false;
    },
    hqReviewStatus() {
      return this.stepRows.find((step) => step.stepName === 'HQ')?.result;
    },
  },
  watch: {},
  created() {
    this.getForm();
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: #000000;
  text-align: left;
  .link {
    color: #243882;
  }
  button:hover {
    text-decoration: underline;
  }
}
.title-container {
  margin-left: 30px;
  margin-top: 30px;
}
.section-title {
  margin-bottom: 30px;
  color: #243882;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  text-transform: uppercase;
  display: block;
}
.item-container {
  display: flex;
  margin-bottom: 20px;
  padding: 35px 30px;
  background: #f5f7f8;
}
input {
  font-size: 14px;
}
.right-container {
  width: 100%;
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  text-transform: uppercase;
  justify-content: center;
  input {
    height: 100px;
    width: initial;
    background: $primary-white;
    border: none;
    margin-bottom: 20px;
  }
  .support-docs {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    span {
      font-weight: normal;
      text-transform: none;
    }
  }
  h4 {
    font-size: 14px;
    font-weight: normal;
    text-transform: none;
    margin: 0px;
  }
  ol,
  ul {
    margin: 0px;
    padding-left: 15px;
    li {
      font-size: 14px;
      font-weight: normal;
      text-transform: none;
    }
  }
  .description {
    margin-bottom: 15px;
  }
}
.left-container {
  min-width: 80px;
}
.description {
  margin-bottom: 10px;
}
.bottom-container {
  margin: 0px 0 20px 30px;
  display: flex;
  flex-direction: column;
  .radio-container {
    margin: 0px 15px 0px 0px;
  }
}
.bottom-info {
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  .info {
    margin-bottom: 15px;
  }
  input {
    width: initial;
    background: $primary-white;
    border: 1px solid #a3a3a3;
    margin-bottom: 20px;
    margin-right: 30px;
    &:read-only {
      cursor: default;
      background: #d1d1d1;
    }
    width: 250px;
  }
  .dial {
    margin-bottom: 40px;
    display: flex;
    align-items: center;
  }
  .label {
    margin-bottom: 20px;
  }
}
.button-container {
  margin-top: 40px;
  align-items: center;
  justify-content: flex-start;
  button {
    margin-right: 15px;
  }
}
.date {
  width: 160px;
  background: $input-background;
  border: none;
  margin-bottom: 20px;
  margin-right: 20px;
  padding: 13px 0px 13px 20px;
}
.signature-input {
  align-items: flex-end;
  margin: 0px 40px;
  .signature-icon {
    margin-right: 10px;
    svg {
      height: 12px;
      width: 12px;
      path {
        fill: #d1d1d1 !important;
      }
    }
  }
  #signature {
    background: $primary-white;
    border-bottom: solid 1px #d1d1d1;
    width: 350px !important;
    ::v-deep {
      canvas {
        width: 350px !important;
      }
    }
  }
}
.signature-confirmation {
  font-size: 12px;
  margin-left: 60px;
}
.signature-buttons {
  justify-content: flex-end;
  margin-top: 20px;
  .right-btn {
    margin-left: 20px;
  }
}

.appeal-container {
  .appeal-details {
    margin: 40px 30px 20px 30px;
  }
  .form-info {
    margin-bottom: 20px;
    span:not(:first-child) {
      margin: 0 15px;
    }
    span:first-child {
      margin-right: 15px;
    }
  }
}
.form-container {
  margin-top: 45px;
}
.radio {
  background: white !important;
}
.radio-selected {
  background: white !important;
}
.section-label {
  color: $primary-black;
  font-size: 14px;
  text-transform: uppercase;
  margin-bottom: 20px;
  display: block;
  font-weight: bold;
  line-height: 20px;
}
.signature-section {
  width: 464px;
  border: 1px solid #a3a3a3;
}
.custom-input-buttons {
  padding: 0px 15px 15px;
  align-items: center;
  .separator {
    color: #d1d1d1;
    margin: 0px 7.5px;
  }
  .edit-button {
    font-size: 14px;
    color: #243882;
    cursor: pointer;
  }
  .disabled {
    opacity: 0.7;
    cursor: default;
    pointer-events: none;
  }
}
.cancel-button {
  background-color: $primary-white;
  border: 1px solid $primary;
  color: $primary;
}
.request-details {
  margin-bottom: 45px;
  ul {
    border: 1px solid #d1d1d1;
    margin: 0px;
    padding: 20px;
    width: 704px;
    list-style-type: none;
    li {
      font-size: 14px;
      color: $primary-black;
      margin-bottom: 15px;
      span {
        font-weight: bold;
        font-size: 14px;
      }
    }
    li:last-child {
      margin-bottom: 0px;
    }
  }
}
.input-info {
  margin-top: 20px;
  .custom-input {
    border: 1px solid $border;
    width: 289px;
    height: 47px;
    justify-content: space-between;
    input {
      border: none;
      padding: 0px 0px 0px 15px;
      height: 100%;
      outline: none;
      margin-right: 0px;
    }
    .custom-input-buttons {
      padding-bottom: 0px;
    }
  }
}
</style>
